import { User } from '@api';
import {
    Avatar, Tooltip, TooltipProps, Typography, styled, tooltipClasses, useTheme
} from '@mui/material';
import { ReactNode } from 'react';

import styles from './UserTooltip.module.scss';


function UserTooltipContent({ user }: { user: User }) {
    const theme = useTheme();

    return (
        <div className={styles.root}>
            <Avatar
                className={styles.avatar}
                sx={{ bgcolor: user.avatarColor || theme.palette.primary.main }}
            >
                {`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}
            </Avatar>

            <div>
                <Typography variant="body2">
                    {`${user.firstName} ${user.lastName}`}
                </Typography>

                <Typography
                    variant="caption"
                    color="textSecondary"
                >
                    {user.email}
                </Typography>
            </div>
        </div>
    );
}

export const UserTooltip = styled(({ className, user, ...props }: Omit<TooltipProps, 'title'> & {user: User, title?: ReactNode}) => (
    <Tooltip
        title={<UserTooltipContent user={user} />}
        placement="left"
        arrow
        enterDelay={500}
        enterNextDelay={500}
        classes={{ popper: className }}
        {...props}
    />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'rgba(255, 255, 255, 0.93)',
        color: theme.palette.text.primary,
        maxWidth: 300,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[3],
        padding: theme.spacing(1.5),
        borderRadius: theme.shape.borderRadius
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.background.paper,
        '&::before': {
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: 'rgba(255, 255, 255, 0.93)',
            boxShadow: theme.shadows[1]
        }
    }
}));
